import { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import * as routesNames from '../../constants/routes'
import AppLayout from '../../config/default/default'
import { Loader } from '../../components'
import { useAuth } from '../../hooks/useAuth'
import SSO from "../SSO/SSO";


const Login = lazy(() => import('../Login'));
const Dashboard = lazy(() => import('../Dashboard'));
const CreateIdea = lazy(() => import('../Idea/CreateIdea'));
const IdeaList = lazy(() => import('../Idea/IdeaList'));
const IdeaDetail = lazy(() => import("../Idea/IdeaDetail"));
const MyIdeas = lazy(() => import("../Idea/MyIdea"));




const AppRoutes = () => {
  const { loggedin, hasPermission } = useAuth();

  return (
    <Routes>
      {!loggedin ? (
        <>
          <>
             <Route path="/sso" element={<SSO />} />
            <Route path={routesNames.LOGIN} element={<Suspense fallback={<Loader />}> <Login /> </Suspense>} />
            <Route path="*" element={<Navigate to={routesNames.LOGIN} />} />
            {/* <Route path={routesNames.FORGOTPASSWORD} element={<Suspense fallback={<Loader />}><ForgotPassword /></Suspense>} /> */}
          </>
        </>) :
        <>
          {hasPermission("Dashboard") && (<Route path={routesNames.DASHBOARD} element={<Suspense fallback={<Loader />}><AppLayout><Dashboard /></AppLayout></Suspense>} />)}
          {hasPermission("Idea", "CreateIdea") && (<Route path={routesNames.CREATEIDEA} element={<Suspense fallback={<Loader />}><AppLayout><CreateIdea /></AppLayout></Suspense>} />)}
          {hasPermission("Idea", "IdeaList") && (<Route path={routesNames.IDEALIST} element={<Suspense fallback={<Loader />}><AppLayout><IdeaList /></AppLayout></Suspense>} />)}
          {hasPermission("Idea", "IdeaDetails") && (<Route path={routesNames.IDEADETAILS} element={<Suspense fallback={<Loader />}><AppLayout><IdeaDetail /></AppLayout></Suspense>} />)}
          {hasPermission("Idea", "MyIdeas") && (< Route path={routesNames.MYIDEAS} element={<Suspense fallback={<Loader />}><AppLayout><MyIdeas /></AppLayout></Suspense>} />)}
          <Route path='*' element={<Navigate to={routesNames.DASHBOARD} />} />

        </>}
    </Routes>
  )
}

export default AppRoutes
